import { themedUseStyletron } from '../../../theme/customTheme'
import { OverviewPanelWrapper } from '../../components/OverviewPanelWrapper'
import { IEdgeDevice } from './types';
import { IconEdgeDevice } from './IconEdgeDevice';
import { useGetRelationsOutByIdQuery } from '../../../services/objects';
import { FormattedMessage } from 'react-intl';
import { useObjectAlarms } from '../../../hooks/useObjectAlarms';
import { Badge, COLOR, SHAPE } from 'baseui/badge';
import { ParagraphMedium, ParagraphXSmall } from 'baseui/typography';


export function OverviewPanel(props: IEdgeDevice) {
    const [, theme] = themedUseStyletron();
    const { items: alarms } = useObjectAlarms(props.id, props.resourceGroupId)

    const { data: nodesIn, isLoading, isSuccess, error } = useGetRelationsOutByIdQuery({ objectId: props.id, type: 'HasConnection', resourceGroupId: props.resourceGroupId }, { skip: !props.id });
    const errSum = alarms?.length || 0 > 0;
    const isOn = !props.noConnection;
    return (
        <OverviewPanelWrapper isOn={isOn} small icon={<IconEdgeDevice color={theme.colors.backgroundPrimary} ></IconEdgeDevice>} {...props} errSum={errSum} >
             {isOn &&  <Badge hierarchy='secondary' color='positive' content={<FormattedMessage id="EdgeDevice.IsConnected" defaultMessage="Is connected" />} />}
            <ParagraphMedium margin={0}>
                <Badge content={nodesIn?.length} shape={SHAPE.pill} color={COLOR.accent}></Badge> <FormattedMessage id="Devices.BACnetDevices" defaultMessage="BACnet Device(s)" />
            </ParagraphMedium>
        </OverviewPanelWrapper>
    );
}